import BigNumber from "bignumber.js";
import { BASE18, environment } from "src/configs/constance";
import { handleEmit } from "src/contract-logic/logic";
import { isNullAddress } from "src/utils";
import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/BattleHandABI.json";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";
import { io } from "socket.io-client";

const { BATTLE_HAND_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;
var socket = null;

const initSocket = () => {
  if (!socket) {
    console.debug("init socket");
    socket =
      environment == "mainnet"
        ? io("https://backend-nft-app.trava.finance", { path: "/battles" })
        : io("ws://178.128.216.246:3579/");
  }
};

const disconnectSocket = () => {
  if (socket) {
    console.debug("manual disconnect socket.io");
    socket.disconnect();
    socket = undefined;
  }
};

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, BATTLE_HAND_ADDRESS);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, BATTLE_HAND_ADDRESS);
  return contractSender;
}

const createRoom = async (dispatch, betPrice, hash, option, uniqueId, accountAddress, bnb) => {
  let emit;
  if (option == 0)
    emit = getContractSender()
      .methods.createRoom(betPrice, hash, option, uniqueId)
      .send({ from: accountAddress, value: bnb });
  else emit = getContractSender().methods.createRoom(betPrice, hash, option, uniqueId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Create Room");
  const res = await emit;
  if (res.events.RoomCreated) {
    const event = res.events.RoomCreated;
    if (socket) socket.emit("RoomCreated", parseInt(event.returnValues.roomId));
    return { status: "success", roomId: parseInt(event.returnValues.roomId) };
  } else throw new Error("Event not found");
};

const closeRoom = async (dispatch, roomId, accountAddress) => {
  const emit = getContractSender().methods.closeRoom(roomId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Close Room");
  const res = await emit;
  if (res.events.RoomClosed) {
    const event = res.events.RoomClosed;
    if (socket) {
      socket.emit("RoomClosed", parseInt(event.returnValues.roomId));
    }
    return {
      status: "success",
      roomId: event.returnValues.roomId,
    };
  } else {
    throw new Error("Event not found");
  }
};

const claimVictoryReady = async (dispatch, roomId, accountAddress) => {
  const emit = getContractSender().methods.claimVictoryReady(roomId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Claim Victory");
  const res = await emit;
  if (res.events.RoomFinished) {
    const event = res.events.RoomFinished;
    if (socket) {
      socket.emit("RoomFinished", parseInt(event.returnValues.roomId));
    }
    return {
      status: "success",
      roomId: event.returnValues.roomId,
      rewardAmount: BigNumber(event.returnValues.rewardAmount).dividedBy(BASE18).toNumber(),
    };
  } else {
    throw new Error("Event not found");
  }
};

const enterRoom = async (dispatch, roomId, sequence, uniqueId, accountAddress, bet, option) => {
  const emit = getContractSender()
    .methods.enterRoom(roomId, sequence, uniqueId)
    .send({ from: accountAddress, value: option === 0 ? bet : 0 });

  handleEmit(dispatch, emit, "Enter Room");
  const res = await emit;
  if (res.events.RoomJoined) {
    const event = res.events.RoomJoined;
    if (socket) socket.emit("RoomJoined", parseInt(event.returnValues.roomId));
    return { status: "success", roomId: event.returnValues.roomId };
  } else throw new Error("Event not found");
};

const resolve = async (dispatch, roomId, sequence, password, accountAddress) => {
  const emit = getContractSender().methods.resolve(roomId, sequence, password).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Resolve Room");
  const res = await emit;
  if (res.events.RoomFinished) {
    const event = res.events.RoomFinished;
    if (socket) {
      socket.emit("RoomFinished", parseInt(event.returnValues.roomId));
    }
    return {
      status: "success",
      roomId: event.returnValues.roomId,
      rewardAmount: BigNumber(event.returnValues.rewardAmount).dividedBy(BASE18).toNumber(),
    };
  } else {
    throw new Error("Event not found");
  }
};

const claimBnbRewards = async (dispatch, accountAddress) => {
  const emit = getContractSender().methods.claimBnbRewards().send({ from: accountAddress });
  handleEmit(dispatch, emit, "Claim BNB Reward");
  const res = await emit;
  if (res.events.RewardClaimed) {
    return {
      status: "success",
    };
  } else {
    throw new Error("Event not found");
  }
};

const claimErc20Rewards = async (dispatch, accountAddress, option) => {
  const emit = getContractSender().methods.claimErc20Rewards(option).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Claim ERC20 Reward");
  const res = await emit;
  if (res.events.RewardClaimed) {
    return {
      status: "success",
    };
  } else {
    throw new Error("Event not found");
  }
};

const updatePrice = async (dispatch, roomId, betAmount, bnb, option, accountAddress) => {
  const emit = getContractSender()
    .methods.updatePrice(roomId, betAmount)
    .send({ from: accountAddress, value: option == 0 ? bnb : 0 });
  handleEmit(dispatch, emit, "Update Room's Bet Amount");
  const res = await emit;
  if (res.events.PriceUpdated) {
    const event = res.events.PriceUpdated;
    if (socket) {
      socket.emit("PriceUpdated", parseInt(event.returnValues.roomId));
    }
    return {
      status: "success",
    };
  } else {
    throw new Error("Event not found");
  }
};

const leaveRoom = async (dispatch, roomId, accountAddress) => {
  const emit = getContractSender().methods.leaveRoom(roomId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Leave Room");
  const res = await emit;
  if (res.events.RoomLeft) {
    const event = res.events.RoomLeft;
    if (socket) {
      socket.emit("RoomLeft", parseInt(event.returnValues.roomId));
    }
    return {
      status: "success",
    };
  } else {
    throw new Error("Event not found");
  }
};

const getHash = async (sequence, password) => {
  const res = await getContractReader().methods.getHash(sequence, password).call();
  return res;
};
const getJoiningTime = async (roomId) => {
  const res = await getContractReader().methods.getJoiningTime(roomId).call();
  return parseInt(res);
};
const getActiveRoomCount = async () => {
  const res = await getContractReader().methods.getActiveRoomCount().call();
  return parseInt(res);
};

const getRoomInfo = async (roomId) => {
  const res = await getContractReader().methods.getRoomInfo(roomId).call();
  if (isNullAddress(res.playerOne)) {
    throw new Error("Room not found");
  }
  return {
    roomId: parseInt(roomId),
    playerOne: res.playerOne,
    playerTwo: isNullAddress(res.playerTwo) ? null : res.playerTwo,
    status: parseInt(res.status),
    betAmount: BigNumber(res.betAmount).dividedBy(BASE18).toNumber(),
    option: parseInt(res.option),
    playerOneSequence: res.playerOneSequence.length ? res.playerOneSequence.map((i) => parseInt(i)) : null,
    playerTwoSequence: res.playerTwoSequence.length ? res.playerTwoSequence.map((i) => parseInt(i)) : null,
    result: parseInt(res.result),
    coinflipResult: res.coinflipResult,
    hostRegisteredUnique: parseInt(res.hostRegisteredUnique),
    playerRegisteredUnique: parseInt(res.playerRegisteredUnique),
    rewardAmount: BigNumber(res.rewardAmount).dividedBy(BASE18).toNumber(),
  };
};

const getTimeout = async () => {
  const res = await getContractReader().methods.getTimeout().call();
  return parseInt(res);
};

const getUnclaimedBnbReward = async (player) => {
  const res = await getContractReader().methods.getUnclaimedBnbReward(player).call();
  return BigNumber(res).dividedBy(BASE18).toNumber();
};

const getUnclaimedErc20Reward = async (player, option) => {
  const res = await getContractReader().methods.getUnclaimedErc20Reward(player, option).call();
  return BigNumber(res).dividedBy(BASE18).toNumber();
};

const getJoinedRoomCount = async (player) => {
  const res = await getContractReader().methods.getJoinedRoomCount(player).call();
  return parseInt(res);
};
const getHostedRoomCount = async (player) => {
  const res = await getContractReader().methods.getHostedRoomCount(player).call();
  return parseInt(res);
};

const listenEventInListRoom = (
  roomCreatedCallback,
  priceUpdatedCallback,
  roomFinishedCallback,
  roomClosedCallback,
  roomJoinedCallback,
  roomLeftCallBack
) => {
  try {
    socket.on("RoomCreated", (roomId) => {
      roomCreatedCallback && roomCreatedCallback(parseInt(roomId));
    });
    socket.on("PriceUpdated", (roomId) => {
      priceUpdatedCallback && priceUpdatedCallback(parseInt(roomId));
    });
    socket.on("RoomFinished", async (roomId) => {
      roomFinishedCallback && roomFinishedCallback(parseInt(roomId));
    });
    socket.on("RoomClosed", async (roomId) => {
      roomClosedCallback && roomClosedCallback(parseInt(roomId));
    });
    socket.on("RoomJoined", (roomId) => {
      roomJoinedCallback && roomJoinedCallback(parseInt(roomId));
    });
    socket.on("RoomLeft", (roomId) => {
      roomLeftCallBack && roomLeftCallBack(parseInt(roomId));
    });
  } catch (error) {
    console.error(error);
  }
};

export default {
  ABI,
  ADDRESS: BATTLE_HAND_ADDRESS,
  createRoom,
  closeRoom,
  getHash,
  claimVictoryReady,
  resolve,
  enterRoom,
  getActiveRoomCount,
  getRoomInfo,
  getJoiningTime,
  getUnclaimedBnbReward,
  getUnclaimedErc20Reward,
  claimBnbRewards,
  claimErc20Rewards,
  getTimeout,
  updatePrice,
  getJoinedRoomCount,
  getHostedRoomCount,
  leaveRoom,
  initSocket,
  listenEventInListRoom,
  disconnectSocket,
};
